import { useEffect, useState } from "react";
import {
  validateDropdown,
  validateEmail,
  validateText,
} from "../../../components/InputFields/ValidationFunctions";
import { useDispatch } from "react-redux";
import {
  getCMSUserAction,
  getRolesAction,
  lookupCMSUserByEmailAction,
  saveCMSUserAction,
  updateCMSUserAction,
} from "../../../store/Users/UsersAction";
import Toastiy from "../../../components/universal/Toastiy";
import { useNavigate } from "react-router-dom";
import { readLanguageAction } from "../../../store/Languages/LanguageAction";
import { setShowNavigationAlertAction } from "../../../store/GlobalLoader/GlobalLoaderAction";
import { getServerMessage } from "../../../utils/apiMessage";
import { assignChurchAdminRequest } from "../../../store/Churches/actions";
import { fetchChurches as fetchChurchEntities } from "../../../store/Churches/churches";
import {
  CHURCH_ADMIN_ROLE_NAME,
  CHANNEL_ADMIN_ROLE_NAME,
  MINISTRY_ADMIN_ROLE_NAME,
} from "../Constants";

export const AddUserHooks = (id) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [value, setValue] = useState("");
  const onChangeSearchBar = (e) => {
    setValue(e.target.value);
  };
  const [profilePic, setProfilePic] = useState("");

  const initialValues = {
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    country: "",
    dob: "",
    password: "",
    confirmPassword: "",
  };

  const [userValues, setUserValues] = useState(initialValues);
  const [roles, setRoles] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [churchOptions, setChurchOptions] = useState([]);
  const [channelOptions, setChannelOptions] = useState([]);
  const [ministryOptions, setMinistryOptions] = useState([]);
  const [assignedChurchPills, setAssignedChurchPills] = useState([]);
  const [emailLookup, setEmailLookup] = useState({ status: "idle" });
  const [emailLookupLoading, setEmailLookupLoading] = useState(false);

    // states for forms here

  // const [firstName, setFirstName] = useState("");
  // const [lastName, setLastName] = useState("");
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  // const [role, setRole] = useState("");
  //handlers for forms here

  const setShowNavigationAlert = (value) => {
    dispatch(setShowNavigationAlertAction(value));
  };

  useEffect(() => {
    return () => {
      setShowNavigationAlert(false);
    };
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUserValues((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "email" ? { userAuthId: "" } : {}),
    }));
    if (name === "email") {
      setEmailLookup({ status: "idle" });
    }
    setShowNavigationAlert(true);
  };

  const handleSelectChange = (event) => {
    const { value, name } = event.target;
    if (name === "roleCode") {
      const selectedRole = roles.find((role) => role.shortCode === value);
      setUserValues((prev) => ({
        ...prev,
        roleCode: value,
        roleName: selectedRole?.roleName || prev?.roleName,
      }));
    } else if (name === "gender") {
      setUserValues((prev) => ({
        ...prev,
        gender: value,
      }));
    } else if (name === "language_prefference") {
      setUserValues((prev) => ({
        ...prev,
        language_prefference: value,
      }));
    } else if (name === "churchObjId") {
      setUserValues((prev) => ({
        ...prev,
        churchObjId: value,
      }));
    } else if (name === "channelObjId") {
      setUserValues((prev) => ({
        ...prev,
        channelObjId: value,
      }));
    } else if (name === "ministriesObjId") {
      setUserValues((prev) => ({
        ...prev,
        ministriesObjId: value,
      }));
    }
    setShowNavigationAlert(true);
  };

  const fetchEntityOptions = async (typeofentity, setter, labelKeyCandidates = []) => {
    try {
      const res = await fetchChurchEntities({ typeofentity });
      const entityList = Array.isArray(res?.data) ? res.data : [];

      setter(
        entityList.map((item) => ({
          roleName:
            labelKeyCandidates.map((key) => item?.[key]).find(Boolean) ||
            item?.churchName ||
            item?._id,
          value: item?._id,
          shortCode: item?._id,
        }))
      );
    } catch (error) {
            setter([]);
    }
  };

  const getSelectedRoleName = () => {
    if (userValues?.roleName) return userValues.roleName;
    return roles.find((role) => role.shortCode === userValues?.roleCode)?.roleName || "";
  };

  const selectedRoleName = getSelectedRoleName();

  const getOptionsForRole = () => {
    if (selectedRoleName === CHURCH_ADMIN_ROLE_NAME) return churchOptions;
    if (selectedRoleName === CHANNEL_ADMIN_ROLE_NAME) return channelOptions;
    if (selectedRoleName === MINISTRY_ADMIN_ROLE_NAME) return ministryOptions;
    return [];
  };

  const getSelectedAssignmentId = () => {
    if (selectedRoleName === CHURCH_ADMIN_ROLE_NAME) return userValues?.churchObjId;
    if (selectedRoleName === CHANNEL_ADMIN_ROLE_NAME) return userValues?.channelObjId;
    if (selectedRoleName === MINISTRY_ADMIN_ROLE_NAME) return userValues?.ministriesObjId;
    return "";
  };

  const getAssignmentField = () => {
    if (selectedRoleName === CHURCH_ADMIN_ROLE_NAME) {
      return {
        type: "dropdown",
        label: "Church",
        placeholder: "Select church",
        options: churchOptions,
        htmlFor: "churchObjId",
        name: "churchObjId",
        defaultValue: "placeholder",
        value: userValues.churchObjId || "placeholder",
        handleInputChange: handleSelectChange,
        validateFunction: validateDropdown,
      };
    }

    if (selectedRoleName === CHANNEL_ADMIN_ROLE_NAME) {
      return {
        type: "dropdown",
        label: "Channel",
        placeholder: "Select channel",
        options: channelOptions,
        htmlFor: "channelObjId",
        name: "channelObjId",
        defaultValue: "placeholder",
        value: userValues.channelObjId || "placeholder",
        handleInputChange: handleSelectChange,
        validateFunction: validateDropdown,
      };
    }

    if (selectedRoleName === MINISTRY_ADMIN_ROLE_NAME) {
      return {
        type: "dropdown",
        label: "Ministry",
        placeholder: "Select ministry",
        options: ministryOptions,
        htmlFor: "ministriesObjId",
        name: "ministriesObjId",
        defaultValue: "placeholder",
        value: userValues.ministriesObjId || "placeholder",
        handleInputChange: handleSelectChange,
        validateFunction: validateDropdown,
      };
    }

    return null;
  };

  const isEntityAdminRole = () =>
    [
      CHURCH_ADMIN_ROLE_NAME,
      CHANNEL_ADMIN_ROLE_NAME,
      MINISTRY_ADMIN_ROLE_NAME,
    ].includes(selectedRoleName);

  const getCreateResolvedUserAuthId = () =>
    emailLookup?.status === "auth0_only" ? emailLookup?.auth0User?.userAuthId : "";

  const getResponseUserAuthId = (res) =>
    res?.data?.[0]?.userAuthId ||
    res?.data?.userAuthId ||
    res?.userAuthId ||
    getCreateResolvedUserAuthId();

  const finishSuccessfulSave = (message = "User Saved Successfully!") => {
    Toastiy(message, 1);
    setShowNavigationAlert(false);
    setTimeout(() => navigate("/users/all"), 500);
  };

  const assignSelectedEntityAdmin = (userAuthId, successMessage, failureMessage) => {
    const selectedAssignmentId = getSelectedAssignmentId();
    const shouldAssignEntityAdmin =
      isEntityAdminRole() && selectedAssignmentId && selectedAssignmentId !== "placeholder";

    if (!shouldAssignEntityAdmin) {
      finishSuccessfulSave(successMessage);
      return;
    }

    if (!userAuthId) {
      Toastiy("User saved, but userAuthId was not returned for entity admin assignment");
      return;
    }

    dispatch(
      assignChurchAdminRequest(
        {
          _id: selectedAssignmentId,
          userAuthId,
        },
        (assignRes) => {
          if (assignRes?.type === 1) {
            finishSuccessfulSave(successMessage);
          } else {
            Toastiy(getServerMessage(assignRes, failureMessage));
          }
        }
      )
    );
  };

  const getEmailLookupHelper = () => {
    if (id !== undefined) return {};
    if (emailLookupLoading) {
      return {
        helperText: "Checking Auth0 and CMS users...",
        helperTone: "info",
      };
    }

    if (emailLookup?.status === "auth0_only") {
      return {
        helperText: "Auth0 user found. CMS profile will be created using the existing Auth0 identity.",
        helperTone: "success",
      };
    }

    if (emailLookup?.status === "cms_existing") {
      return {
        helperText: "This user already exists in CMS. Open the existing user and update from the users list.",
        helperTone: "error",
      };
    }

    if (emailLookup?.status === "email_conflict") {
      return {
        helperText: "Email conflict found between Auth0 and CMS. Please review the existing user before creating.",
        helperTone: "error",
      };
    }

    if (emailLookup?.status === "not_found") {
      return {
        helperText: "No existing Auth0 or CMS user found. A new Auth0 identity will be created.",
        helperTone: "info",
      };
    }

    if (emailLookup?.status === "error") {
      return {
        helperText: emailLookup?.message || "Unable to lookup this email right now.",
        helperTone: "error",
      };
    }

    return {};
  };

  const lookupEmailInAuth0AndCMS = () => {
    if (id !== undefined) return;

    const email = (userValues?.email || "").trim();
    if (!validateEmail(email)) {
      setEmailLookup({ status: "idle" });
      return;
    }

    setEmailLookupLoading(true);
    dispatch(
      lookupCMSUserByEmailAction({
        apiPayloadRequest: { email },
        callback: (res) => {
          setEmailLookupLoading(false);
          if (res?.type !== 1) {
            setEmailLookup({
              status: "error",
              message: getServerMessage(res, "Unable to lookup this email right now"),
            });
            return;
          }

          const lookupData = res?.data || {};
          setEmailLookup(lookupData);

          if (lookupData?.status === "auth0_only" && lookupData?.auth0User) {
            setUserValues((prev) => ({
              ...prev,
              userAuthId: lookupData.auth0User.userAuthId || prev.userAuthId,
              firstName: prev.firstName || lookupData.auth0User.firstName || "",
              lastName: prev.lastName || lookupData.auth0User.lastName || "",
            }));
            if (!profilePic && lookupData.auth0User.profilePicUrl) {
              setProfilePic(lookupData.auth0User.profilePicUrl);
            }
          }
        },
      })
    );
  };

  const handleDateChange = (value) => {
    setUserValues((prev) => ({
      ...prev,
      dob: value,
    }));
    setShowNavigationAlert(true);
  };

  const handlePhoneChange = (value) => {
    setUserValues((prev) => ({
      ...prev,
      phone: value,
    }));
    setShowNavigationAlert(true);
  };

  const validateURL = (url) => {
    if (!url) return true;
    try {
      const parsed = new URL(url);
      return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch {
      return false;
    }
  };

  const onSave = (e) => {
    if (profilePic && !validateURL(profilePic)) {
      Toastiy("Please enter a valid profile picture URL");
      return;
    }
    const data = {
      firstName: userValues?.firstName,
      lastName: userValues?.lastName,
      gender: userValues?.gender,
      phone: userValues?.phone,
      email: userValues?.email,
      country: userValues?.country,
      language_prefference: userValues?.language_prefference,
      roleCode: userValues?.roleCode,
      password: userValues?.password,
      dob: userValues?.dob,
      profilePicUrl: profilePic,
    };

    const resolvedUserAuthId = getCreateResolvedUserAuthId();
    if (resolvedUserAuthId) {
      data.userAuthId = resolvedUserAuthId;
      delete data.password;
    }


    if (id !== undefined) {
      dispatch(
        updateCMSUserAction({
          apiPayloadRequest: {
            userAuthId: userValues?.userAuthId,
            lastName: userValues?.lastName,
            firstName: userValues?.firstName,
            gender: userValues?.gender,
            mobile: userValues?.phone,
            email: userValues?.email,
            country: userValues?.country,
            language_prefference: userValues?.language_prefference,
            roleCode: userValues?.roleCode,
            dob: userValues?.dob,
            profilePicUrl: profilePic,
            churchObjId: userValues?.churchObjId,
            channelObjId: userValues?.channelObjId,
            ministriesObjId: userValues?.ministriesObjId,
          },
          callback: (res) => {
            if (res?.type === 1) {
              assignSelectedEntityAdmin(
                userValues?.userAuthId,
                "User Updated Successfully!",
                "Failed to assign entity admin"
              );
            } else {
              Toastiy(getServerMessage(res, "Failed to update user details"));
            }
          },
        })
      );
    } else {
      if (emailLookup?.status === "cms_existing" || emailLookup?.status === "email_conflict") {
        Toastiy(getEmailLookupHelper()?.helperText || "Please review this email before creating");
        return;
      }

      if (!resolvedUserAuthId && !userValues?.password) {
        Toastiy("Password is required for new Auth0 users");
        return;
      }

      if (!resolvedUserAuthId && userValues?.password !== userValues?.confirmPassword) {
        Toastiy("Password do not match");
        return;
      }
      dispatch(
        saveCMSUserAction({
          apiPayloadRequest: data,
          callback: (res) => {
            if (res?.type === 1) {
              assignSelectedEntityAdmin(
                getResponseUserAuthId(res),
                "User Saved Successfully!",
                "User saved, but failed to assign entity admin"
              );
            } else {
              Toastiy(getServerMessage(res, "Failed to save user details"));
            }
          },
        })
      );
    }
  };
  const onCancel = (e) => {};

  const getAssignedEntityIds = (data) => ({
    churchObjId: data?.churchObjId || data?.assignedEntities?.churches?.[0]?._id || "",
    channelObjId: data?.channelObjId || data?.assignedEntities?.channels?.[0]?._id || "",
    ministriesObjId:
      data?.ministriesObjId || data?.assignedEntities?.ministries?.[0]?._id || "",
  });

  const getAssignedChurchPills = (data) => {
    const churches = Array.isArray(data?.assignedEntities?.churches)
      ? data.assignedEntities.churches
      : [];

    return churches
      .map((church) => ({
        id: church?._id || church?.churchObjId || church?.value,
        label: church?.churchName || church?.name || church?.title || church?._id,
      }))
      .filter((church) => church.id && church.label);
  };

  const UserFields = [
    {
      type: "text",
      label: "First Name",
      placeholder: "Enter first name",
      htmlFor: "firstName",
      name: "firstName",
      value: userValues.firstName,
      handleInputChange: handleInputChange,
      validateFunction: validateText,
    },
    {
      type: "text",
      label: "Last Name",
      placeholder: "Enter last name",
      htmlFor: "lastName",
      name: "lastName",
      value: userValues.lastName,
      handleInputChange: handleInputChange,
      validateFunction: validateText,
    },
    ...(getCreateResolvedUserAuthId()
      ? []
      : [
          {
            type: "text",
            label: "Set Password",
            placeholder: "Set your Password",
            htmlFor: "password",
            name: "password",
            value: userValues.password,
            handleInputChange: handleInputChange,
            validateFunction: validateText,
          },
          {
            type: "text",
            label: "Confirm Password",
            placeholder: "Confirm your Password",
            htmlFor: "password",
            name: "confirmPassword",
            value: userValues.confirmPassword,
            handleInputChange: handleInputChange,
            validateFunction: validateText,
          },
        ]),
    {
      type: "text",
      label: "Email ID",
      placeholder: "Enter Email ID",
      htmlFor: "email",
      name: "email",
      value: userValues.email,
      handleInputChange: handleInputChange,
      handleBlur: lookupEmailInAuth0AndCMS,
      validateFunction: validateEmail,
      ...getEmailLookupHelper(),
    },
    {
      type: "phone",
      label: "Phone",
      placeholder: "Enter Phone Number",
      htmlFor: "phone",
      name: "phone",
      value: userValues.phone,
      handleInputChange: handlePhoneChange,
      validateFunction: validateText,
    },
    {
      type: "image",
      name: "profilePic",
      label: "Upload Profile Picture",
      urlLabel: "Upload Profile Pic URL",
      urlPlaceholder: "Enter profile picture URL",
      value: profilePic,
      handleInputChange: setProfilePic,
      validateFunction: validateText,
    },
    {
      type: "dropdown",
      label: "Role",
      placeholder: "Select role",
      options: roles,
      htmlFor: "roleCode",
      name: "roleCode",
      defaultValue: "placeholder",
      value: userValues.roleCode,
      handleInputChange: handleSelectChange,
      validateFunction: validateDropdown,
    },
    ...(getAssignmentField() ? [getAssignmentField()] : []),
    {
      type: "dropdown",
      label: "Gender",
      placeholder: "Select gender",
      options: [
        { value: "Male", roleName: "Male", shortCode: "Male" },
        { value: "Female", roleName: "Female", shortCode: "Female" },
      ],
      htmlFor: "gender",
      name: "gender",
      defaultValue: "placeholder",
      value: userValues.gender,
      handleInputChange: handleSelectChange,
      validateFunction: validateDropdown,
    },
    {
      type: "text",
      label: "Country",
      placeholder: "Enter Country Name",
      htmlFor: "country",
      name: "country",
      value: userValues.country,
      handleInputChange: handleInputChange,
      validateFunction: validateText,
    },
    {
      type: "dropdown",
      label: "Language Preference",
      placeholder: "Select language",
      defaultValue: "placeholder",
      options: languages,
      name: "language_prefference",
      htmlFor: "language_prefference",
      value: userValues.language_prefference,
      handleInputChange: handleSelectChange,
      validateFunction: validateDropdown,
    },
    {
      type: "date",
      label: "Date of Birth",
      placeholder: "Select Date",
      htmlFor: "dob",
      name: "dob",
      value: userValues.dob,
      handleInputChange: handleDateChange,
      validateFunction: validateText,
    },
  ];

  const UserFields2 = [
    {
      type: "text",
      label: "First Name",
      placeholder: "Enter first name",
      htmlFor: "firstName",
      name: "firstName",
      value: userValues.firstName,
      handleInputChange: handleInputChange,
      validateFunction: validateText,
    },
    {
      type: "text",
      label: "Last Name",
      placeholder: "Enter last name",
      htmlFor: "lastName",
      name: "lastName",
      value: userValues.lastName,
      handleInputChange: handleInputChange,
      validateFunction: validateText,
    },
    {
      type: "text",
      label: "Email ID",
      placeholder: "Enter Email ID",
      htmlFor: "email",
      name: "email",
      value: userValues.email,
      handleInputChange: handleInputChange,
      validateFunction: validateEmail,
    },
    {
      type: "phone",
      label: "Mobile",
      placeholder: "Enter Phone Number",
      htmlFor: "phone",
      name: "phone",
      value: userValues.phone,
      handleInputChange: handlePhoneChange,
      validateFunction: validateText,
    },
    {
      type: "image",
      name: "profilePic",
      label: "Upload Profile Picture",
      urlLabel: "Upload Profile Pic URL",
      urlPlaceholder: "Enter profile picture URL",
      value: profilePic,
      handleInputChange: setProfilePic,
      validateFunction: validateText,
    },
    {
      type: "dropdown",
      label: "Role",
      placeholder: "Select role",
      options: roles,
      htmlFor: "roleCode",
      name: "roleCode",
      defaultValue: "placeholder",
      value: userValues.roleCode,
      handleInputChange: handleSelectChange,
      validateFunction: validateDropdown,
    },
    ...(assignedChurchPills.length > 0
      ? [
          {
            type: "pillGroup",
            label: "Assigned Churches",
            pills: assignedChurchPills,
          },
        ]
      : []),
    ...(getAssignmentField() ? [getAssignmentField()] : []),
    {
      type: "dropdown",
      label: "Gender",
      placeholder: "Select gender",
      options: [
        { value: "Male", roleName: "Male", shortCode: "Male" },
        { value: "Female", roleName: "Female", shortCode: "Female" },
      ],
      htmlFor: "gender",
      name: "gender",
      defaultValue: "placeholder",
      value: userValues.gender,
      handleInputChange: handleSelectChange,
      validateFunction: validateDropdown,
    },
    {
      type: "text",
      label: "Country",
      placeholder: "Enter Country Name",
      htmlFor: "country",
      name: "country",
      value: userValues.country,
      handleInputChange: handleInputChange,
      validateFunction: validateText,
    },
    {
      type: "dropdown",
      label: "Language Preference",
      placeholder: "Select language",
      defaultValue: "placeholder",
      options: languages,
      name: "language_prefference",
      htmlFor: "language_prefference",
      value: userValues.language_prefference,
      handleInputChange: handleSelectChange,
      validateFunction: validateDropdown,
    },
    {
      type: "date",
      label: "Date of Birth",
      placeholder: "Select Date",
      htmlFor: "dob",
      name: "dob",
      value: userValues.dob,
      handleInputChange: handleDateChange,
      validateFunction: validateText,
    },
  ];

  useEffect(() => {
    dispatch(
      getRolesAction({
        callback: (res) => {
          if (res?.type === 1) {
            setRoles(res?.data?.map((d) => ({ ...d, value: d?.r, shortCode: d?.r })));
          }
        },
      })
    );
    dispatch(
      readLanguageAction({
        callback: (res) => {
                    if (res?.type === 1) {
            setLanguages(
              res?.data?.map((d) => ({
                roleName: d?.language_name,
                value: d?.language_name,
                shortCode: d?.language_code,
              }))
            );
          }
        },
      })
    );

    fetchEntityOptions("1", setChurchOptions, ["churchName"]);
    fetchEntityOptions("2", setChannelOptions, ["channelName", "churchName"]);
    fetchEntityOptions("3", setMinistryOptions, ["ministryName", "churchName"]);

    if (id !== undefined) {
      dispatch(
        getCMSUserAction({
          apiPayloadRequest: {
            _id: id,
          },
          callback: (res) => {
            if (res?.type === 1) {
              const data = res?.data.filter((item) => item._id === id)[0];
              const assignedEntityIds = getAssignedEntityIds(data);
              const assignedChurches = getAssignedChurchPills(data);
              const dob =
                data?.dob && new Date(data?.dob)?.toString() !== "Invalid Date" ? data?.dob : "";

              setUserValues({
                firstName: data?.firstName,
                lastName: data?.lastName,
                gender: data?.gender,
                phone: data?.mobile,
                email: data?.email,
                country: data?.country,
                profilePicUrl: data?.profilePicUrl,
                language_prefference: data?.language_prefference,
                roleCode: data?.roleCode,
                roleName: data?.roleName,
                dob: dob,
                password: data?.password,
                userAuthId: data?.userAuthId,
                churchObjId: assignedEntityIds.churchObjId,
                channelObjId: assignedEntityIds.channelObjId,
                ministriesObjId: assignedEntityIds.ministriesObjId,
              });
              setProfilePic(data?.profilePicUrl);
              setAssignedChurchPills(assignedChurches);

            }
          },
        })
      );
    }
  }, []);

  return {
    value,
    onChangeSearchBar,
    UserFields,
    UserFields2,
    onSave,
    onCancel,
  };
};
